import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, RefreshCw, Sparkles } from "lucide-react";
import FeedbackView from "@/components/admin/views/FeedbackView";

const SECTIONS = [
    ["top_requested_features", "Top requested features"],
    ["common_complaints", "Most common complaints"],
    ["most_loved", "Most loved"],
    ["reasons_caregivers_return", "Why caregivers return"],
    ["reasons_caregivers_stop", "Why caregivers stop"],
];

export default function ResearchFeedback() {
    const [data, setData] = useState(null);
    const [err, setErr] = useState(null);
    const [refreshing, setRefreshing] = useState(false);

    const load = () => api.get("/admin/os/feedback-summary").then(r => setData(r.data)).catch(e => setErr(e?.response?.data?.detail || "Failed to load"));
    useEffect(() => { load(); }, []);

    const refresh = async () => {
        setRefreshing(true);
        try { const r = await api.post("/admin/os/feedback-summary/refresh"); setData(r.data); } catch { /* keep old */ }
        setRefreshing(false);
    };

    return (
        <div className="space-y-5" data-testid="research-feedback">
            <div className="flex items-start justify-between gap-3 flex-wrap">
                <div>
                    <h2 className="font-heading font-bold text-2xl text-[#12776F]">Research & feedback</h2>
                    <p className="text-sm text-[#6E7A74]">AI synthesis of {data?.total_feedback ?? "…"} feedback entries (PMF, surveys, in-app). Raw inbox preserved below.</p>
                </div>
                <button onClick={refresh} disabled={refreshing} data-testid="research-refresh"
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-dark hover:underline disabled:opacity-50">
                    <RefreshCw size={14} className={refreshing ? "animate-spin" : ""} /> Re-synthesize
                </button>
            </div>

            {err && <div className="ml-card p-5 text-coral-dark">{err}</div>}
            {!data && !err && <div className="ml-card p-8 flex items-center gap-2 text-[#6E7A74]" data-testid="research-loading"><Loader2 size={16} className="animate-spin" /> Synthesizing caregiver feedback…</div>}

            {data && (
                data.ai_available ? (
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="research-ai-summary">
                        {SECTIONS.map(([key, label]) => (
                            <div key={key} className="ml-card p-4">
                                <h3 className="font-heading font-semibold text-sm flex items-center gap-1.5 text-teal-dark">
                                    <Sparkles size={13} /> {label}
                                </h3>
                                <ul className="mt-2 space-y-1.5 text-sm text-[#1F2624] list-disc pl-4">
                                    {(data.summary?.[key] || []).map((s, i) => <li key={i}>{s}</li>)}
                                </ul>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="ml-card p-5 text-sm text-[#6E7A74]" data-testid="research-ai-unavailable">
                        AI synthesis unavailable right now — raw feedback below still works. Try “Re-synthesize”.
                    </div>
                )
            )}

            <FeedbackView />
        </div>
    );
}
